import axios from "axios";

// Na VPS, front e API usam o mesmo domínio. A variável é opcional para dev.
const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export const getCloudServers = async () => {
  const response = await axios.get(`${API_URL}/api/cloud/servers`, { timeout: 10000, withCredentials: true });
  if (!Array.isArray(response.data)) throw new Error("Resposta cloud inválida");
  return response.data;
};

export const getCloudHistory = async (id, hours = 1) => {
  const response = await axios.get(`${API_URL}/api/cloud/servers/${id}/history`, {
    params: { hours }, timeout: 10000, withCredentials: true,
  });
  if (!Array.isArray(response.data)) throw new Error("Histórico cloud inválido");
  return response.data;
};

export const login = async (password) => {
  const response = await axios.post(`${API_URL}/api/auth/login`, { password }, {
    withCredentials: true,
  });
  return response.data;
};

export const getSession = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/auth/session`, {
      withCredentials: true,
      timeout: 10000,
    });
    return response.data?.authenticated === true;
  } catch (error) {
    if (error.response?.status === 401) return false;
    throw error;
  }
};

export const getComputers = async () => {
  const response = await axios.get(`${API_URL}/api/computers`, {
    timeout: 10000,
    withCredentials: true,
  });
  if (!Array.isArray(response.data)) throw new Error("Resposta inesperada da API");
  return response.data;
};

export const deleteComputer = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/computers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar:", error.message);
    throw error;
  }
};

export const getComputerHistory = async (id, hours = 24) => {
  try {
    console.log(`📊 Buscando histórico do computador ${id} (${hours}h)`);
    const response = await axios.get(
      `${API_URL}/api/computers/${id}/history?hours=${hours}`,
      { timeout: 10000 }
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Erro ao buscar histórico:", error.message);
    return [];
  }
};

export const updateCloudName = async (id, name) => (await axios.patch(`${API_URL}/api/cloud/servers/${id}/name`, { display_name: name })).data;

export const updateComputerName = async (id, customName) => {
  try {
    const response = await axios.patch(
      `${API_URL}/api/computers/${id}/name`,
      { custom_name: customName }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar nome:", error.message);
    throw error;
  }
};
